<template>
  <common-wrap :preview-data="previewData" v-loading="loading">
    <div id="pptx"></div>
  </common-wrap>
</template>

<script>
import commonWrap from "@/components/commonWrap";
import common from "@/mixins/common";

export default {
  name: "ppt-preview",
  mixins: [common],
  components: {
    commonWrap
  },
  async mounted() {
    // this.render();
    this.$emit('render');
    const res = await this.getBlobData();
    if (res) {
      console.log('success');
    }
  },
  methods: {
    // render() {
    //   EventBus.$emit('render');
    //   // $('#pptx').pptxToHtml({
    //   //   pptxFileUrl: this.previewData.fileUrl,
    //   //   slidesScale: "50%",
    //   //   slideMode: false,
    //   //   keyBoardShortCut: false
    //   // })
    // }
  }
}
</script>

<style lang="scss" scoped>
::v-deep #all_slides_warpper {
  width: 100% !important;
  height: 100vh !important;
  margin: 60px auto 0 !important;
  overflow: scroll;
}
</style>
